import { useTranslation } from 'react-i18next'
import {
  Box,
  Divider,
  IconCheckCircleOutline,
  IconDelete,
  IconEdit,
  IconEyeSlash,
  IconRocket,
  IconShareAlt,
  IconVisibility,
  Skeleton
} from '@machobear/design-system'
import { DropdownMenu } from './dropdown-menu'
import { DropdownMenuItem } from './dropdown-menu-item'
import { ListingStateButton } from '../../../components/listing-state-button'
import { useListingActions } from '../../../context/listing-actions'
import { useListingData } from '../../../context/listing-data'
import { useListingDashboardModals } from '../../../modals'

export const Header = () => {
  const { t } = useTranslation()

  const { listingHidden, listingPending, loading } = useListingData()
  const { editListing, markAsRented, hideListing, unhideListing, confirmDeletion } =
    useListingActions()
  const { showModal } = useListingDashboardModals()

  if (loading) return <Skeleton.Header />

  return (
    <Box
      width="full"
      paddingTop="small"
      display="flex"
      flexDirection="row"
      justifyContent="spaceBetween"
      gap="gutter"
    >
      <ListingStateButton />

      <DropdownMenu>
        <DropdownMenuItem icon={<IconEdit />} text={t('Edit')} onClick={editListing} />
        <DropdownMenuItem
          icon={<IconShareAlt size="small" />}
          text={t('Share')}
          onClick={showModal('mainDialog')}
        />
        <DropdownMenuItem
          icon={<IconCheckCircleOutline tone={listingPending ? 'disabled' : 'formAccent'} />}
          text={t('Mark as rented')}
          disabled={listingPending}
          onClick={markAsRented}
        />

        {listingHidden ? (
          <DropdownMenuItem
            icon={<IconVisibility />}
            text={t('Unhide listing')}
            onClick={unhideListing}
          />
        ) : (
          <DropdownMenuItem
            icon={<IconEyeSlash />}
            text={t('Hide listing')}
            onClick={hideListing}
          />
        )}
        <DropdownMenuItem
          icon={<IconRocket />}
          text={t('Boost listing')}
          onClick={showModal('sponsoredListing')}
        />

        <Box paddingY="xsmall">
          <Divider />
        </Box>

        <DropdownMenuItem
          icon={<IconDelete tone="critical" />}
          tone="critical"
          text={t('Delete listing')}
          onClick={confirmDeletion}
        />
      </DropdownMenu>
    </Box>
  )
}
